<div class="action-form">
  <span class="title">{{ 'COMPANY.LOCK_ACCOUNTING_PERIOD_HEADER' | translate }}</span>
  <app-information-block [text]="'COMPANY.LOCK_ACCOUNTING_PERIOD_DESCRIPTION' | translate"></app-information-block>
  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row form-group">
        <div class="col-12 col-md-6 col-lg-4">
          <app-local-date-picker [control]="form.controls['lockDate']"></app-local-date-picker>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12">
          <button class="btn btn-active" type="submit">{{ 'OK_BTN' | translate }}</button>
          <button class="btn link-btn ml-2" (click)="cancel()">{{ 'CANCEL_BTN' | translate }}</button>
        </div>
      </div>
    </form>
  }
</div>
